// extracted by mini-css-extract-plugin
export var brand = "_b2-9";
export var compact = "_b2-6";
export var extraSmall = "_b2-7";
export var icon = "_b2-0";
export var large = "_b2-4";
export var light = "_b2-1";
export var medium = "_b2-5";
export var outline = "_b2-b";
export var primaryDark = "_b2-a";
export var primaryLight = "_b2-8";
export var primaryModern = "_b2-c";
export var success = "_b2-2";
export var successSolid = "_b2-3";